import Vue from 'vue'
import VueRouter from 'vue-router'
import { notification } from 'ant-design-vue'
import store from '../store'

Vue.use(VueRouter)

// 全局路由
const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue'),
    meta: {
      needLogin: true
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      needLogin: false
    }
  },
  // 单点登录路由
  {
    path: '/loginForSso',
    name: 'LoginForSso',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/LoginForSso.vue')
  },
  {
    path: '/no-permission',
    name: 'noPermission',
    component: () => import('../views/error_page/403.vue'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('../components/M_message.vue'),
    meta: {
      needLogin: false
    }
  },
]

// 解决重复点击路由报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history', //去除#号
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: true, // 是否已经添加动态(菜单)路由
  routes
})

// 路由的导航守卫设置beforeEach()钩子的应用
router.beforeEach((to, from, next) => {



  // 移除许可弹窗唯一标记
  let errorCodes = JSON.parse(sessionStorage.getItem('errorCodes')) || []
  errorCodes = errorCodes.filter(i=>{
    console.log(i)
    return (![426,424,423].includes(i))
  })
  sessionStorage.setItem('errorCodes', JSON.stringify(errorCodes))


  if (to.meta.needLogin) {                                                                      //判断是否需要登录
    if (store.state.user.token) {                                                               //根据token判断是否已登录
      Vue.axios.get('/user/getById/' + store.state.user.userId).then((res) => {           //请求用户信息
        if (res.code == 200) {
          // console.log(res.data.result);
          store.commit('user/getInfo', res.data)
          // console.log(store.state.user.userInfo)
          return store.state.user.userInfo.userName
        }
      }).then((uname) => {
        Vue.axios.post('/user/' + uname + '/permissions', '').then((res) => {            //请求用户权限
          if (res.code === 200) {
            store.commit('user/getPermissions', res.data)
            next()
          }
        })
      }).catch((e) => {
        notification.error({message: '系统内部错误：' + e.message})
        next({ name: 'Login' })
      })
    } else {
      next('/login')
    }
  } else {
    next()
  }
})

export default router